/**
 * Document Context Badge Component
 * Shows which document is being used for chat context
 */

import { StudyDocument } from '@voxapilot/shared';

interface DocumentContextBadgeProps {
  document: StudyDocument | null;
  onClear?: () => void;
}

export function DocumentContextBadge({ document, onClear }: DocumentContextBadgeProps) {
  if (!document) return null;

  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 text-sm">
      <svg
        className="w-4 h-4 text-orange-600 dark:text-orange-400 flex-shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
      <span className="text-orange-700 dark:text-orange-300 truncate max-w-[200px]">
        {document.title}
      </span>
      {onClear && (
        <button
          onClick={onClear}
          className="ml-1 text-orange-600 dark:text-orange-400 hover:text-orange-800 dark:hover:text-orange-200 transition-colors"
          title="Clear document context"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}
